import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { BankDetailsEntity } from "./bank-details-entity";
import { BankDetailsService } from "./bank-details-service";
import { BankDetailsController } from "./bank-details-controller";

@Module({
    imports:[
        TypeOrmModule.forFeature([BankDetailsEntity])
    ],
    providers:[BankDetailsService,ApplicationExceptionHandler],
    controllers:[BankDetailsController],
    exports:[BankDetailsService]
})
export class BankDetailsModule{}